import React, { useState } from 'react';
import { Icon } from 'antd';
import cx from 'classnames';
import { Form, Field } from 'react-final-form';

import Button from 'components/Button';
import InputFile from 'components/InputFile';
import CardMaterial from 'materials/CardMaterial';
import SpinMaterial from 'materials/SpinMaterial';
import styles from './UploadByFile.module.css';

type UploadByFileProps = {
  isLoading: boolean;
  isLoadingDownload: boolean;
  initialValues: {
    fileUpload: any;
    fileName: string;
  };
  disabledSubmit: boolean;
  handleDownloadTemplate: () => void;
  handleSubmitUpload: () => void;
  handleUploadFile: (value: any) => void;
};

export default function UploadByFile({
  isLoading,
  isLoadingDownload,
  initialValues,
  disabledSubmit,
  handleDownloadTemplate,
  handleSubmitUpload,
  handleUploadFile,
}: UploadByFileProps) {
  const [showUploadContent, setShowUploadContent] = useState<boolean>(false);

  const openUploadContent = () => {
    if (!showUploadContent) {
      setShowUploadContent(true);
    }
  };

  const closeUploadContent = () => {
    if (showUploadContent) {
      setShowUploadContent(false);
    }
  };

  return (
    <SpinMaterial spinning={isLoading} size="large">
      <CardMaterial
        title={
          <div
            style={{ width: '100%', cursor: 'pointer' }}
            onClick={closeUploadContent}
          >
            <b style={{ color: '#11BEFF' }}>UPLOAD BY FILE</b>
          </div>
        }
        extra={
          <Icon
            type={showUploadContent ? 'up' : 'down'}
            style={{ color: '#11BEFF', cursor: 'pointer' }}
            onClick={closeUploadContent}
          />
        }
        style={{
          borderRadius: '10px',
          cursor: showUploadContent ? 'default' : 'pointer',
        }}
        onClick={showUploadContent ? undefined : openUploadContent}
      >
        {showUploadContent && (
          <Form
            onSubmit={handleSubmitUpload}
            initialValues={{ ...initialValues }}
            validate={values => {
              const errors = {} as any;
              if (!values.fileName) {
                errors.fileName = 'File wajib diisi';
              }
              return errors;
            }}
          >
            {({ handleSubmit, valid }) => (
              <form onSubmit={handleSubmit} className={styles.wrapper}>
                <div className={styles.inputWrapper}>
                  <Field name="fileName">
                    {({ input, meta }) => (
                      <InputFile
                        label="FILE .XLSX"
                        accept=".xls,.xlsx"
                        placeholder="No file chosen"
                        required
                        validateFile={meta.touched && meta.error ? 'error' : ''}
                        error={meta.error && meta.touched && meta.error}
                        handleChangeFile={value => {
                          input.onChange(value.file.name);
                          handleUploadFile(value);
                        }}
                        value={input.value}
                      />
                    )}
                  </Field>
                  <p
                    className={cx(
                      isLoadingDownload && styles.sampleDownloadDisabled,
                      styles.sampleDownload
                    )}
                    onClick={() =>
                      !isLoadingDownload && handleDownloadTemplate()
                    }
                  >
                    {isLoadingDownload ? 'Loading...' : 'Download sample file'}
                  </p>
                </div>
                <Button
                  text="Simpan"
                  htmlType="submit"
                  loading={isLoading}
                  disabled={!valid || disabledSubmit}
                  styles={{ minWidth: 92 }}
                />
              </form>
            )}
          </Form>
        )}
      </CardMaterial>
    </SpinMaterial>
  );
}
